import { createState, useState } from '@hookstate/core';
import { UserInfo } from 'shared/types';

interface AppState {
    user: UserInfo | null;
    sideDrawerOpen: boolean;
}

const initialState: AppState = {
    user: null,
    sideDrawerOpen: false,
};

const appState = createState(initialState);

export function useAppState() {
    return useState(appState);
}
